import { render, staticRenderFns } from "./Primaries.vue?vue&type=template&id=92da2368&"
import script from "./Primaries.vue?vue&type=script&lang=js&"
export * from "./Primaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports